import { Navigate, Route, Routes } from "react-router-dom";
import { Router as PublicRouter } from "./Router";
import { HOME_ROUTE } from "./routing_constants";
import { RoutingV2 } from "../components/application_components/public_landing_page/landing_v2/App";

export function Routing() {
 
  
  return (
    <div>
      <Routes>
        <Route path='v1/public/*' element={<PublicRouter />} />
        <Route path="public/*" element={<RoutingV2 />} />
        <Route path='' element={<Rerouter />} />
        {/* not found route */}
      </Routes>
    </div>
  )
}

export const RoutingMain = () => {

  return (
    <div>
      <Routes>
        <Route path="/*" element={<Routing />} />
      </Routes>
    </div>
  )
}

const Rerouter = () => {

  return (
    <Navigate to={HOME_ROUTE} />
  )
}
